
// Test data for Level 2 Chipping Training

export const chippingTests = [
  {
    id: "chipping-plat",
    title: "Chipping balle levée sur terrain plat",
    description: "Positionner les balles pour les distances D=15, E=20, F=25 m (wedge de 60°, 56°, et 52°), jouer 10 balles et compter les points selon le cercle d'arrivée. Safe zone : zone située derrière le trou où la balle doit s'arrêter pour qu'un chip soit considéré réussi.",
    icon: "⛳"
  },
  {
    id: "chipping-pente-droit",
    title: "Chipping balle levée Pente droite gauche",
    description: "Positionner les balles pour les distances D1=15, E1=20, F1=25 m (wedge de 60°, 56°, et 52°) prêt d'un green en pente, jouer 10 balles et compter les points selon le cercle d'arrivée. Safe zone : zone située derrière le trou où la balle doit s'arrêter pour qu'un chip soit considéré réussi.",
    icon: "⛳"
  },
  {
    id: "chipping-pente-gauche",
    title: "Chipping balle levée Pente gauche droite",
    description: "Positionner les balles pour les distances D2=15, E2=20, F2=25 m (wedge de 60°, 56°, et 52°) prêt d'un green en pente, jouer 10 balles et compter les points selon le cercle d'arrivée. Safe zone : zone située derrière le trou où la balle doit s'arrêter pour qu'un chip soit considéré réussi.",
    icon: "⛳"
  },
  {
    id: "chipping-roulee-plat",
    title: "Chipping balle roulée terrain plat",
    description: "Positionner les balles pour les distances D3=5, E3=10, F3=15 m (fer 7 à 9), jouer 10 balles et compter les points selon le cercle d'arrivée. Safe zone : zone située derrière le trou où la balle doit s'arrêter pour qu'un chip soit considéré réussi.",
    icon: "⛳"
  }
];
